import type { Link } from '../types';

export const getLinkFromPageId = (pageID = '', sysId = ''): Link => ({
    webUrl: `/${pageID}`,
    sysId,
    internalTitle: pageID,
});
